import styles from "../../styles/chatStyles";
import { useModal } from "../../ModalContext";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function MessageBubble({
  message,
  isOwn,
  getTime,
  onReply,
  isSelected,
  isSelectionMode,
  onSelect,
  isHighlighted,
  props
}) {
  const user = localStorage.getItem("user");

  const isFav = message.favoriteBy?.includes(user);
  const isForwarded = message.forwarded;
  const [rolling, setRolling] = useState(false);
  useEffect(() => {
  if (message.type === "dice") {
    setRolling(true);

    // 🔥 играем звук только если сообщение свежее
    const isFresh = Date.now() - message.createdAt < 1000;

    if (isFresh) {
      const audio = new Audio("/sounds/dice.mp3");
      audio.volume = 1;
      audio.play();
    }

    const t = setTimeout(() => {
      setRolling(false);
    }, 600);

    return () => clearTimeout(t);
  }
}, [message.id]);

  const { setUserModal } = useModal();
  const [userData, setUserData] = useState(null);

  const playDiceSound = () => {
  const audio = new Audio("/sounds/dice.mp3");
  audio.volume = 0.4;
  audio.play();
};

  const renderDiceIcon = (d) => {
  const common = {
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.4,
  };

  switch (d) {
    case 4: // треугольник
      return (
        <svg {...common}>
          <polygon points="12,3 21,18 3,18" />
        </svg>
      );

    case 6: // куб
      return (
        <svg {...common}>
          <rect x="4" y="4" width="16" height="16" rx="3" />
        </svg>
      );

    case 8: // ромб
      return (
        <svg {...common}>
          <polygon points="12,2 22,12 12,22 2,12" />
        </svg>
      );

    case 10: // вытянутый
      return (
        <svg {...common}>
          <polygon points="12,2 20,7 17,22 7,22 4,7" />
        </svg>
      );

    case 12: // сложный
      return (
        <svg {...common}>
          <polygon points="12,2 18,4 22,10 20,18 12,22 4,18 2,10 6,4" />
        </svg>
      );

    case 20: // почти круглый
      return (
        <svg {...common}>
          <polygon points="12,2 20,6 22,14 16,22 8,22 2,14 4,6" />
        </svg>
      );

    case 100: // сфера
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
        </svg>
      );

    default:
      return null;
  }
};

  useEffect(() => {
    if (!message?.sender) return;

    const loadUser = async () => {
      try {
        const snap = await getDoc(doc(db, "users", message.sender));
        if (snap.exists()) {
          setUserData(snap.data());
        }
      } catch (e) {
        console.log("Ошибка загрузки юзера:", e);
      }
    };

    loadUser();
  }, [message?.sender]);

  if (!message?.sender) return null;

  const openUser = () => {
    if (!userData) return;

    setUserModal({
      username: message.sender,
      ...userData
    });
  };

return (
  <div
    id={`msg-${message.id}`}
      style={{
        display: "flex",
        justifyContent: isOwn ? "flex-end" : "flex-start",
        marginBottom: 10,
        alignItems: "flex-end",
        gap: 8
      }}
    >
      {!isOwn && (
        <img
          src={userData?.avatar || "https://via.placeholder.com/40"}
          style={styles.msgAvatar}
          onClick={openUser}
        />
      )}

      {/* 💬 Баббл */}
      <div
        id={message.id}
        style={{
          ...styles.msgBubble,
          ...(isOwn ? styles.myBubble : styles.otherBubble),

          ...(isHighlighted && {
            boxShadow: "0 0 25px rgba(255,255,255,0.4)",
          }),

          ...(isSelected && {
            border: "1px solid rgba(255,255,255,0.35)",
            background: "rgba(255,255,255,0.16)",
            transform: "scale(1.02)"
          }),

          overflow: "hidden",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}
        onClick={(e) => {
          if (!isSelectionMode) return;
          e.stopPropagation();
          onSelect?.();
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          onSelect?.();
        }}
      >

        {/* ➡ пересланное */}
        {isForwarded && (
          <div style={{ fontSize: 11, opacity: 0.6, marginBottom: 6 }}>
            Переслано от {message.forwardFrom}
          </div>
        )}

        {/* 🔁 reply */}
        {message.replyTo && (
  <div
    onClick={() => {
      const el = document.getElementById(`msg-${message.replyTo.id}`);
      if (!el) return;

      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      // 💥 триггер подсветки
      if (window.highlightMessage) {
        window.highlightMessage(message.replyTo.id);
      }
    }}
    style={{
      cursor: "pointer",
      padding: "4px 6px",
      borderLeft: "2px solid #818181",
      marginBottom: 4,
      opacity: 0.8,
    }}
  >
    <div style={{ fontSize: 11, opacity: 0.6 }}>
      {message.replyTo.sender}
    </div>
    <div style={{ fontSize: 12 }}>
      {message.replyTo.text}
    </div>
  </div>
)}

        {/* shimmer */}
        {isSelected && <div style={styles.shimmer} />}

        {!isOwn && (
          <div style={{ fontSize: 12, opacity: 0.6, marginBottom: 4 }}>
            {message.sender}
          </div>
        )}

        {/* 🎲 DICE */}
            {message.type === "dice" && (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "6px 8px",
    }}
  >
    <div
      style={{
        transform: rolling ? "rotate(360deg) scale(1.2)" : "none",
        transition: "transform 0.6s cubic-bezier(.2,1.4,.4,1)",
        width: 28,
        height: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {renderDiceIcon(message.dice)}
    </div>

    <div style={{ fontSize: 13, opacity: 0.6 }}>
      d{message.dice}
    </div>

    <div
      style={{
        fontSize: 16,
        fontWeight: "600",
        marginLeft: "auto",
        opacity: rolling ? 0 : 1,
        transition: "opacity 0.3s",
      }}
    >
      {message.value}
    </div>
  </div>
)}

        {/* текст */}
<div style={styles.text}>
  {message.type !== "dice" &&
    (message.forwardText
      ? message.forwardText
      : message.text || null)}
</div>

        {/* картинка */}
        {message.forwardImage ? (
          <img src={message.forwardImage} style={styles.image} />
        ) : message.image ? (
          <img src={message.image} style={styles.image} />
        ) : null}

        {/* низ */}
        <div style={styles.bottomRow}>
          <button
            style={styles.replyBtn}
            onClick={(e) => {
              e.stopPropagation();
              onReply();
            }}
          >
            ↩
          </button>

          <div style={styles.metaRight}>
           {isFav && (
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="white"            // ✅ заливка
                    stroke="none"           // ✅ убираем контур
                    style={{
                    filter: "drop-shadow(0 0 2px rgba(255,255,255,0.6))" // ✨ свечение
                    }}
                >
                <path d="M12 17.3l-5.2 3 1-5.9L3 9.7l6-0.9L12 3l3 5.8 6 0.9-4.8 4.7 1 5.9z" />
              </svg>
            )}

            <div style={styles.msgMeta}>
              {getTime(message.createdAt)?.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
              {isOwn && " ✓✓"}
            </div>
          </div>
        </div>
      </div>

      {isOwn && (
        <img
          src={userData?.avatar || "https://via.placeholder.com/40"}
          style={styles.msgAvatar}
          onClick={openUser}
        />
      )}
    </div>
  );
}